import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import { UiHelpCircleIcon } from "@jti/brand-icons/ui-help-circle";
import { UiWarningIcon } from "@jti/brand-icons/ui-warning";
import styles from "./InputInfoSection.module.scss";
export const InputInfoSection = ({ text, isError, isSuccess }) => {
    return (_jsxs("section", { className: styles.infoSection, children: [isError ? (_jsx("span", { "data-testid": "textInputInfoIcon", className: styles.iconWrapper, children: _jsx(UiWarningIcon, { className: classNames(styles.helperIcon, {
                        [styles.iconError]: isError,
                    }) }) })) : (_jsx("span", { "data-testid": "textInputInfoIcon", className: styles.iconWrapper, children: _jsx(UiHelpCircleIcon, { className: classNames(styles.helperIcon, {
                        [styles.iconSuccess]: isSuccess,
                    }), "data-testid": "textInputInfoIcon" }) })), _jsx("span", { className: classNames(styles.label, {
                    [styles.labelError]: isError,
                    [styles.labelSuccess]: isSuccess,
                }), children: text })] }));
};
//# sourceMappingURL=InputInfoSection.js.map